import React from 'react'
import { useNewFooterStyles } from './footer.styles'
import { Link } from 'react-router-dom'
import { Links } from '../../settings/links'
import { AppFooterLogo } from './new-footer-logo'
import { selectUser } from '../../store/auth/selectors'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

type NewFooterProps = {
  isSpacer?: boolean
}

export const NewFooter: React.FC<NewFooterProps> = ({
  isSpacer = true,
}: NewFooterProps): React.ReactElement => {
  const classes = useNewFooterStyles()
  const user = useSelector(selectUser)
  const getYear = () => new Date().getFullYear()
  const { t } = useTranslation()

  return (
    <React.Fragment>
      {isSpacer && <div className={classes.topSpacer} />}
      <footer className={classes.footerSection}>
        <div className={classes.footerHolder}>
          <div className={classes.footerLogo}>
            <AppFooterLogo resetOffset />
          </div>
          <nav className={classes.footerMenu}>
            <Link className={classes.footerLink} to="/donate">
              {t('header.menu.donate')}
            </Link>
            <Link className={classes.footerLink} to="/about">
              About
            </Link>
            <a
              className={classes.footerLink}
              target="_blank"
              href={Links.help}
              rel="noreferrer"
            >
              {t('header.menu.help')}
            </a>
            <a
              className={classes.footerLink}
              target="_blank"
              href={Links.charities}
              rel="noreferrer"
            >
              {t('header.menu.forNonprofits')}
            </a>
            <a
              className={classes.footerLink}
              target="_blank"
              href={Links.terms}
              rel="noreferrer"
            >
              {t('header.menu.termsForServices')}
            </a>
            <Link className={classes.footerLink} to="/nonprofit-catalog">
              Nonprofit Catalog
            </Link>
            {user.role === 1 && (
              <a
                className={classes.footerLink}
                target="_blank"
                href="/moderation"
                rel="noreferrer"
              >
                {t('header.menu.moderatorView')}
              </a>
            )}
          </nav>
        </div>
        <div className={classes.subFooter}>
          <span>Copyright © {getYear()} Prosphora. All Rights Reserved.</span>
        </div>
      </footer>
    </React.Fragment>
  )
}
